import { api } from "@web/lib/api";
import type { ThreadSummary } from "@shared/api";
import type {
  MailCollection,
  MailCategory,
  CategoryChange,
  SavedMailView,
  FilingSuggestion,
} from "@shared/library";
export const categoriesKey = ["saved-mail", "categories"] as const;
export const libraryKey = ["saved-mail"] as const;
export interface LibraryFilters {
  collection?: string;
  q?: string;
  year?: string;
  attachments?: string;
}
export const libraryApi = {
  list: (filters: LibraryFilters, cursor?: string) => {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(filters)) if (value) params.set(key, value);
    if (cursor) params.set("cursor", cursor);
    return api<{ items: SavedMailView[]; nextCursor: string | null }>(`/api/library?${params}`);
  },
  item: (threadKey: string) =>
    api<{ item: SavedMailView | null; thread: ThreadSummary | null }>(
      `/api/library/item?${new URLSearchParams({ threadKey })}`,
    ),
  categories: () => api<MailCategory[]>("/api/library/categories"),
  createCategory: (name: string) =>
    api<CategoryChange & { category: MailCategory }>("/api/library/categories", {
      method: "POST",
      body: { name },
    }),
  renameCategory: (id: string, name: string) =>
    api<CategoryChange>("/api/library/categories/rename", { method: "POST", body: { id, name } }),
  removeCategory: (id: string) =>
    api<CategoryChange>("/api/library/categories/remove", { method: "POST", body: { id } }),
  undoCategory: (id: string) =>
    api<{ categories: MailCategory[] }>("/api/library/categories/undo", {
      method: "POST",
      body: { id },
    }),
  save: (input: {
    threadKey: string;
    collection?: MailCollection | undefined;
    collections?: MailCollection[] | undefined;
    note: string;
    tags: string[];
    remember: boolean;
  }) =>
    api<{ item: SavedMailView; thread: ThreadSummary | null; undoId: string }>("/api/library", {
      method: "POST",
      body: input,
    }),
  undo: (id: string) => api("/api/library/undo", { method: "POST", body: { id } }),
  remove: (threadKey: string) =>
    api("/api/library/remove", { method: "POST", body: { threadKey } }),
  restore: (threadKey: string) =>
    api("/api/library/restore", { method: "POST", body: { threadKey } }),
  suggestions: () => api<FilingSuggestion[]>("/api/library/suggestions"),
  preferences: () =>
    api<{ id: string; sender: string; collection: string; accountId: string }[]>(
      "/api/library/preferences",
    ),
  restorePreference: (id: string) =>
    api("/api/library/preferences/restore", { method: "POST", body: { id } }),
  forget: (id: string) =>
    api<{ undoId: string }>("/api/library/preferences/remove", { method: "POST", body: { id } }),
};
